import { useState } from "react";
import { api, formatErr } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Landmark, Plus, Trash2 } from "lucide-react";
import { toast } from "sonner";

export const BancheDialog = ({ banche, company, onChange }) => {
  const [open, setOpen] = useState(false);
  const [f, setF] = useState({ nome: "", abbreviazione: "", iban: "" });
  const co = company === "all" ? "golmar" : company;
  const add = async () => {
    try {
      await api.post("/banche", { ...f, company: co, abbreviazione: f.abbreviazione.toUpperCase() });
      setF({ nome: "", abbreviazione: "", iban: "" }); onChange();
    } catch (e) { toast.error(formatErr(e.response?.data?.detail)); }
  };
  const del = async (id) => { await api.delete(`/banche/${id}`); onChange(); };
  return (
    <>
      <Button size="sm" variant="outline" className="h-8 gap-1" onClick={() => setOpen(true)} data-testid="pn-banche-button">
        <Landmark className="w-4 h-4" />Banche
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-xl">
          <DialogHeader><DialogTitle>Elenco banche</DialogTitle></DialogHeader>
          <div className="text-xs text-muted-foreground -mt-2">All'import dell'estratto conto la banca viene riconosciuta da IBAN o nome; le banche nuove vengono aggiunte qui da sole.</div>
          <table className="autotrans-table w-full" data-testid="banche-table">
            <thead><tr><th>Sigla</th><th>Nome</th><th>IBAN</th><th>Az.</th><th></th></tr></thead>
            <tbody>
              {banche.length === 0 && <tr><td colSpan={5} className="text-center py-4 text-muted-foreground">Nessuna banca</td></tr>}
              {banche.map((b) => (
                <tr key={b.id} data-testid={`banca-row-${b.id}`}>
                  <td className="font-mono font-bold">{b.abbreviazione}</td><td>{b.nome}</td>
                  <td className="font-mono text-xs">{b.iban || "—"}</td><td className="text-xs">{b.company}</td>
                  <td><Button size="icon" variant="ghost" className="h-7 w-7 text-destructive" onClick={() => del(b.id)} data-testid={`banca-delete-${b.id}`}><Trash2 className="w-3.5 h-3.5" /></Button></td>
                </tr>
              ))}
            </tbody>
          </table>
          <div className="grid grid-cols-[90px_1fr_1fr_auto] gap-2">
            <Input placeholder="Sigla" className="h-8" value={f.abbreviazione} onChange={(e) => setF({ ...f, abbreviazione: e.target.value })} data-testid="banca-field-sigla" />
            <Input placeholder="Nome banca" className="h-8" value={f.nome} onChange={(e) => setF({ ...f, nome: e.target.value })} data-testid="banca-field-nome" />
            <Input placeholder="IBAN (facoltativo)" className="h-8" value={f.iban} onChange={(e) => setF({ ...f, iban: e.target.value })} data-testid="banca-field-iban" />
            <Button size="sm" className="h-8 gap-1" disabled={!f.nome || !f.abbreviazione} onClick={add} data-testid="banca-add-button"><Plus className="w-4 h-4" />Aggiungi</Button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
